<template>
  <div class="footer">
    <div class="footer__top">
      <ul class="footer__social-networks social-networks">
        <li
          class="social-networks__item"
          v-for="(social,index) in socialNetworks"
          :key="`${social.name}_${index}`"
        >
          <a
            :class="`social-networks__${social.icon} footer__link`"
            :href="social.link"
            target="_blank"
            rel="noreferrer noopener"
            :aria-label="social.alt"
          >
            {{social.name}}
            <i :class="`icon icon__${social.icon}`" />
          </a>
        </li>
      </ul>
    </div>
    <div class="footer__middle">
      <div class="footer__links">
        <h4 class="footer__links-title">Informações:</h4>
        <ul class="footer__links-list">
          <li v-for="(link, index) in links" :key="`${link.name}_${index}`">
            <router-link :to="link.href" :title="link.title" :aria-label="link.name">{{ link.name }}</router-link>
          </li>
        </ul>
      </div>

      <div class="footer__attendance">
        <h4 class="footer__attendance-title">Horário de atendimento:</h4>
        <p class="footer__attendance-schedule">Segunda a sexta, das 9h às 19h</p>
        <div class="footer__attendance-details">
          <a href="mailto:contato@bravarcorretora.com.br" class="footer__attendance-mail">comercial@bralife.com.br</a>
          <a href="tel:+552122833149" class="footer__attendance-phone">(21) 2283 - 3149</a>
          <a href="tel:+552122833115" class="footer__attendance-phone">(21) 2283 - 3115 (Whats App)</a>
        </div>
      </div>
      <div class="footer__address">
        <h4 class="footer__address-title">Endereço:</h4>
        <a
          href="https://www.google.com.br/maps/place/Pra%C3%A7a+Pio+X,+78+-+Centro,+Rio+de+Janeiro+-+RJ,+20040-020/@-22.9002205,-43.1801022,17z/data=!3m1!4b1!4m5!3m4!1s0x997f59160ea52b:0x22ee285ebbc15d4d!8m2!3d-22.9002205!4d-43.1779135"
          target="_blank"
          rel="noreferrer noopener"
          class="footer__address-location"
        >Praça Pio X, 78 salas 912 | 914 - Centro, Rio de Janeiro</a>
      </div>
    </div>
    <div class="footer__bottom">
      <p class="footer__copyrights">Bralife 2019 - Um produto &copy; Bravar Corretora de Seguros LTDA - CNPJ: 26.994.511/0001-60 / SUSEP: 10.2037425.9</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      socialNetworks: [
        {
          name: "LinkedIn",
          icon: "linkedin",
          alt: "Ícone da rede social LinkedIn",
          title: "Acesse o nosso LinkedIn",
          link: "https://www.linkedin.com/company/bravar-corretora-de-seguros/"
        },
        {
          name: "Facebook",
          icon: "facebook",
          alt: "Íconde da rede social Facebook",
          title: "Acesse o nosso Facebook",
          link: "https://www.facebook.com/Bralife-Seguros-de-Vida-111482116896601 "
        },
        {
          name: "Instagram",
          icon: "instagram",
          alt: "Ícone de rede social Instagram",
          title: "Acesse o nosso Instagram",
          link: "https://www.instagram.com/__BRALIFE__/"
        }
      ],
      links: [
        {
          name: "Sobre o serviço",
          href: "/sobre-servico",
          title: "Veja aqui inforções detalhadas sobre o serviço!"
        },
        {
          name: "Benefícios",
          href: "/sobre-beneficios",
          title: "Veja aqui todos os benefícios de contratar com a Bralife!"
        },
        {
          name: "Coberturas",
          href: "/sobre-coberturas",
          title: "Veja aqui inforções detalhadas sobre as coberturas inclusas!"
        },
        {
          name: "Termos e condições",
          href: "/termos-e-condicoes",
          title: "Entenda todos os nossos termos e condições de uso do site!"
        }
      ]
    };
  }
};
</script>
<style lang="scss">
.footer {
  font-size: $font-size__md;
  box-shadow: $shadow__footer;

  &__top {
    background-image: $default-linear-gradient;
  }

  .social-networks {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: $space__sm;

    @include breakpoint($desk__min--sm) {
      padding: $space__md;
    }

    &__item {
      padding: 0 $space__sm;
      a {
        font-size: 0;

        .icon {
          font-size: $font-size__st;
        }
      }
    }
  }

  &__link,
  &__link:visited {
    font-size: $font-size__st;
    color: $color__white;
  }

  &__middle {
    padding: $space__md;

    @include breakpoint("min-width: 375px") {
      display: grid;
      grid-template-areas:
        "links contacts"
        "address address";
      grid-column-gap: $space__sm;
      grid-row-gap: $space__st;
    }

    @include breakpoint($desk__min--sm) {
      grid-template-areas: "links contacts address";
      grid-template-columns: repeat(3, 30%);
      grid-column-gap: $space__st;
      grid-row-gap: $space__xl;
      justify-content: center;
    }
  }

  &__links-list,
  &__attendance,
  &__address {
    line-height: 1.5;

    a, a:visited, a:focus {
      color: $color__blue;
    }
  }

  &__links-list {
    flex-direction: column;
  }

  &__attendance {
    grid-area: contacts;

    @include breakpoint("max-width: 374px") {
      margin: $space__st 0;
    }

    &-schedule, &-details {
      padding: $space__md;
      background: #f5f5f5;
    }

    &-schedule {
      margin: $space__sm 0;
    }

    &-details {
      display: flex;
      flex-direction: column;
    }
  }

  &__address {
    grid-area: address;

    &-title {
      @include breakpoint-range("min-width: 375px", $desk__max--sm) {
        text-align: center;
      }

    }
  }

  &__bottom {
    padding: $space__md;
    background: $color__gray-light;
  }

  &__copyrights {
    font-size: $font-size__xs;
    text-align: center;
  }
}
</style>